import { useInfiniteQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { listScheduledRuns } from '@/services/schedules/list-scheduled-runs';
import type {
  ListScheduledRunsParams,
  ListScheduledRunsResponse,
} from '@/types/schedules';

export const SCHEDULED_RUNS_PAGE_SIZE = 30;

export const scheduledRunsQueryKey = (
  orgId?: string,
  params: ListScheduledRunsParams = {},
) => ['scheduled-runs', orgId, params];

export const useListScheduledRuns = (params: ListScheduledRunsParams = {}) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useInfiniteQuery<ListScheduledRunsResponse, Error>({
    queryKey: scheduledRunsQueryKey(orgId, params),
    queryFn: ({ pageParam }) =>
      listScheduledRuns(orgId!, {
        ...params,
        limit: SCHEDULED_RUNS_PAGE_SIZE,
        offset: pageParam as number,
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const offset = lastPage.offset ?? 0;
      const limit = lastPage.limit ?? SCHEDULED_RUNS_PAGE_SIZE;
      const total = lastPage.total ?? 0;
      const next = offset + limit;
      return next < total ? next : undefined;
    },
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 1,
  });
};
